const getPager = (totalPageCount: number, currentPage = 1, pagesToShow = 7) => {
  // Helpers
  const toBounds = (value: number, min: number, max: number) =>
    Math.min(Math.max(value, min), max);

  // Calculate total pages
  const itemsEachSide = Math.floor(pagesToShow / 2);

  // Bounds check currentPage
  const boundCurrentPage = toBounds(currentPage, 1, totalPageCount);

  // Determine base start and end pages with evenly distributed side values
  const baseStartPage = Math.max(boundCurrentPage - itemsEachSide, 1);
  const baseEndPage = Math.min(
    boundCurrentPage + itemsEachSide,
    totalPageCount
  );
  const showBaseStartPage = baseStartPage + pagesToShow;
  const showBaseEndPage = baseEndPage - pagesToShow;

  // Determine extra items needed to sides when nearing bounds
  const startPage =
    showBaseEndPage >= 1 ? Math.min(baseStartPage, showBaseEndPage + 1) : 1;
  const endPage =
    showBaseStartPage <= totalPageCount
      ? Math.max(baseEndPage, showBaseStartPage - 1)
      : totalPageCount;
  const pageArrayLength = Math.min(endPage - startPage + 1, pagesToShow);

  // Create the pages array
  const pages = new Array(pageArrayLength)
    .fill(0)
    .map((_, index) => startPage + index);

  // return object with all pager properties required by the view
  return {
    currentPage: boundCurrentPage,
    pagesToShow,
    pages,
  };
};

export default getPager;
